import React, { useId } from 'react'
import PropTypes from 'prop-types'

const BellIcon = React.forwardRef(function BellIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path d="M22 17C20.9 17 20 16.1 20 15V9C20 4.59 16.41 1 12 1C7.59 1 4 4.59 4 9V15C4 16.1 3.1 17 2 17C1.45 17 1 17.45 1 18C1 18.55 1.45 19 2 19H8C8 21.21 9.79 23 12 23C14.21 23 16 21.21 16 19H22C22.55 19 23 18.55 23 18C23 17.45 22.55 17 22 17ZM12 21C10.9 21 10 20.1 10 19H14C14 20.1 13.1 21 12 21ZM5.46 17C5.8 16.41 6 15.73 6 15V9C6 5.69 8.69 3 12 3C15.31 3 18 5.69 18 9V15C18 15.73 18.2 16.41 18.54 17H5.46Z"></path>
    </svg>
  )
})

BellIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

BellIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default BellIcon
